const SCRIPT_ID = 'google-identity-services'
let loadPromise = null

export function loadGoogleIdentity() {
  if (window.google && window.google.accounts) return Promise.resolve(window.google)
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID)
    const script = existing || document.createElement('script')
    script.id = SCRIPT_ID
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.google)
    script.onerror = () => reject(new Error('Google 로그인 모듈을 불러오지 못했습니다.'))
    if (!existing) document.head.appendChild(script)
  })
  return loadPromise
}
